import { translate } from "../../helpers";
export const buildBaseProps = (event, dict) => {
    return {
        title: buildTitle(event.liveGameState, event.leagueName, dict),
        team1Name: event.team1Name,
        team2Name: event.team2Name
    };
};
const buildTitle = (liveGameState, leagueName, dict) => {
    return liveGameState.gamePart ? translate(dict, liveGameState.gamePart) : leagueName;
};
//# sourceMappingURL=buildBaseProps.js.map